import React from 'react';
import AddProductPage from './AddProductPage';

/** Factory-only: register a raw material (name + category). No qty or prices on this form. */
export default function AddRawMaterialPage({ onNavigate }) {
  return <AddProductPage onNavigate={onNavigate} rawMaterialOnly />;
}
